// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZGfe","colBig":"styles_colBig__2tvZ-","colSmall":"styles_colSmall__3FFqO"};